import {Button, Stack, Typography} from "@mui/material";
import CloseIcon from "assets/icons/Close";
import React from "react";

const FilterTitle = ({onClear}: {onClear: () => void}) => {
  return (
    <Stack direction={'row'} justifyContent={'space-between'}>
      <Typography variant={'h4'}>Фильтр</Typography>
      <Button startIcon={<CloseIcon sx={{color: 'primary.main'}}/>} onClick={() => onClear()}>
        Сбросить
      </Button>
    </Stack>
  )
}

export default FilterTitle
